module.exports = __webpack_public_path__ + "145685c1291bae8a2720aaeabc21bbd0.png";